import { TypeNav, TypeNavControlResource, TypeNavKey } from 'Type'

const HookNavResource = (key :TypeNavKey, nav? :TypeNav<any>) :TypeNavControlResource | undefined => {
    const resource :TypeNavControlResource | undefined = nav?.control.resource[key]
    return resource
}

export default HookNavResource